(function () {
  "use strict";

  seriesTypeModel.$inject = ['mtypes'];
  angular
    .module('trainerWebApp.services')
    .factory('seriesTypeModel', seriesTypeModel);

  function seriesTypeModel(mtypes) {

    var currentType = mtypes.seriesType.default_;

    var service = {
      sequenceEnforced: false,
      courseFailureEnforced: false,
      init: init,
      save: save,
      reset: reset,
      isDirty: isDirty
    };

    return service;

    ///////////////


    function init(value) {
      currentType = value;

      setTypeOfSeries(currentType);
    }

    function save() {
      currentType = getTypeOfSeries();
      setTypeOfSeries(currentType);

      return currentType;
    }

    function reset() {
      setTypeOfSeries(currentType);
    }

    function isDirty() {
      return currentType != getTypeOfSeries();
    }

    function setTypeOfSeries(value) {

      switch (value) {
        case mtypes.seriesType.sequenceEnforced:
          service.sequenceEnforced = true;
          service.courseFailureEnforced = false;
          break;
        case mtypes.seriesType.courseFailureEnforced:
          service.sequenceEnforced = true;
          service.courseFailureEnforced = true;
          break;
        default:
          service.sequenceEnforced = false;
          service.courseFailureEnforced = false;
      }
    }

    function getTypeOfSeries() {

      var type = mtypes.seriesType.default_;

      if(service.sequenceEnforced) {
        type = mtypes.seriesType.sequenceEnforced;

        if(service.courseFailureEnforced) {
          type = mtypes.seriesType.courseFailureEnforced;
        }
      }

      return type;
    }

  }

})();
